import React, { memo, useRef } from 'react';
import { connect } from 'react-redux';
import action from '@flux/action';
import { Button } from 'antd';
import { useHistory } from 'react-router-dom';
import ProjectModuleSetting from '../projectSetting/projectModuleSetting';
import { formatCreateProjectDate } from '@utils/common';
import { oldProjectRoleNames } from '@model';
import alert from '@components/alert';
import { projectModuleAddModalConfigOnSystemSetting } from '@model/settings/addModalConfig';
import { validateSubmoduleName } from '@modules/systemSetting/systemModule/helper';
import { setSessionStorage } from '@utils/windowUtil';

const ModuleDetailForm = (props) => {
  const moduleFormRef = useRef();
  const history = useHistory();
  const {
    steps,
    tranStep,
    projects,
    saveData,
    clientData,
    memberData,
    groupData,
    moduleFormData,
    saveCreateProjectData,
    saveCustomizedModules,
    operatorName,
    saveProject,
    emptyGroupData,
    clearClientData,
  } = props;

  const getGroupData = () => groupData;

  const handlePrevious = () => {
    const formData = moduleFormRef.current?.getModuleForm().getFieldsValue();
    // saveCustomizedModules({
    //   ...formData,
    // });
    saveCreateProjectData({
      ...saveData,
      currentStep: tranStep(steps[0]),
      ...formData,
    });
    history.push(`/projects/create/${steps[0]}`);
  };

  const handleSubmit = async () => {
    const members = [...new Set(memberData)].filter((member) => member?.email);
    for (const i in members) {
      switch (members[i].role_name) {
        case oldProjectRoleNames[0]:
          members[i].isManager = false;
          members[i].isLead = true;
          break;
        case oldProjectRoleNames[1]:
          members[i].isManager = true;
          members[i].isLead = false;
          break;
        default:
          members[i].isManager = false;
          members[i].isLead = false;
      }
    }
    try {
      await moduleFormRef.current?.getModuleForm().validateFields();
    } catch (e) {
      console.log(e);
      const error =
        e.errorFields && e.errorFields[0] && e.errorFields[0].errors[0];
      alert.warning(error);
      return;
    }
    const moduleData = moduleFormRef.current?.getModuleForm().getFieldsValue();
    // sendEmail stored on row when user validated email in Client step (string 'yes' or 'no'); no second API call
    const clientList = (saveData.clientList || [])
      .filter((item) => item?.email?.trim?.())
      .map((client) => ({
        email: client.email,
        isEUBased: client.isEUBased,
        role_name: client.role_name,
        name: client.name,
        sendEmail:
          client.sendEmail != null && String(client.sendEmail) === 'no'
            ? 'no'
            : 'yes',
      }));

    const result = {
      operatorName,
      ...saveData,
      ...moduleData,
      clientList,
      members,
      groupSetting: [...groupData],
    };

    if (result.anticipatedAnnouncementDate) {
      result.anticipatedAnnouncementDate = formatCreateProjectDate(
        result.anticipatedAnnouncementDate.years(),
        result.anticipatedAnnouncementDate.month() + 1,
        result.anticipatedAnnouncementDate.date(),
      );
    } else {
      result.anticipatedAnnouncementDate = null;
    }
    if (result.targetDealCloseDate) {
      result.targetDealCloseDate = formatCreateProjectDate(
        result.targetDealCloseDate.years(),
        result.targetDealCloseDate.month() + 1,
        result.targetDealCloseDate.date(),
      );
    } else {
      result.targetDealCloseDate = null;
    }

    if (Array.isArray(result?.customizeModule)) {
      result.customizeModule.forEach((i) =>
        !i.groupPermissions ? (i.groupPermissions = []) : null,
      );
    }

    if (!validateSubmoduleName(result?.customizeModule)) {
      return;
    }

    if (result.buyerName) {
      delete result.buyerCompanyInfo;
    }
    if (result.targetName || result.isSingleCompany) {
      delete result.targetCompanyInfo;
    }

    delete result.buyerDuns;
    delete result.targetDuns;
    delete result.currentNum;
    delete result.currentStep;
    delete result.isEditing;
    delete result.lastNum;

    delete result.stepOneFinish;
    delete result.targetCheck;
    delete result.buyerCheck;

    const { success, id, hasAuth, companyData } = await saveProject(result);
    if (success) {
      setSessionStorage('newProjectId', id);
      setSessionStorage('hasAuth', hasAuth);
      setSessionStorage('newProjectName', saveData.projectName);
      saveCreateProjectData({
        ...saveData,
        companyData,
        currentStep: tranStep(steps[1]),
      });
      emptyGroupData();
      clearClientData();
      history.push(`/projects/create/${steps[1]}`);
    } else {
      console.log('error', result);
    }
  };

  const renderAction = () => (
    <div className="form-actions-wrapper setting-btns">
      <Button className="previous-btn" onClick={handlePrevious}>
        previous
      </Button>

      <Button className="ok-btn" onClick={handleSubmit}>
        create project
      </Button>
    </div>
  );

  return (
    <ProjectModuleSetting
      cRef={moduleFormRef}
      hideHomeSections
      createStep
      moduleFormData={moduleFormData}
      getGroupData={getGroupData}
      renderAction={renderAction}
      changeTab={handlePrevious}
      addModuleConfig={projectModuleAddModalConfigOnSystemSetting}
    />
  );
};

const mapStateToProps = ({ projects, login }) => ({
  projects,
  clientData: projects.clientData || {},
  groupData: projects.groupData,
  memberData: projects.memberData,
  saveData: projects.saveData,
  moduleFormData: { customizeModule: projects.saveData.customizeModule },
  operatorName: `${login.userInfo.given_name} ${login.userInfo.family_name}`,
});

const mapDispatchToProps = (dispatch) => ({
  saveCustomizedModules(data) {
    dispatch(action.saveCustomizedModules(data));
  },
  saveCreateProjectData(data) {
    dispatch(action.saveData(data));
  },
  async saveProject(data) {
    return await dispatch(action.addProject(data));
  },
  emptyGroupData() {
    dispatch(action.changeGroupsDetail([]));
  },
  clearClientData() {
    dispatch(action.changeClientsDetail({}));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(ModuleDetailForm));
